 export class FormFieldWithValidityState {
    constructor(currentValue, isValid, isTouched) {
        this.currentValue = currentValue;
        this.isTouched = isTouched;
        this.isValid = isValid;
    }

    static initialDefaults(initialValue) {
        return new FormFieldWithValidityState(initialValue, false, false);
    }

    equals(other) {
        return this.isValid === other.isValid &&
            this.isTouched === other.isTouched &&
            this.currentValue === other.currentValue;
    }
}

export class FormFieldWithValidityAndUniqueness extends FormFieldWithValidityState {
    constructor(currentValue, isValid, isTouched, isUnique) {
        super(currentValue, isValid, isTouched);
        this.isUnique = isUnique;
    }

    static initialDefaults(initialValue) {
        return new FormFieldWithValidityAndUniqueness(initialValue, false, false, true);
    }

    equals(other) {
        return super.equals(other) && this.isUnique === other.isUnique;
    }
}